export default __webpack_public_path__ + "static/media/count.147a0a5c.png";